import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import AdminActionModule from '@/modules/admin-action';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/admin-action')({
  component: AdminActionPage,
});

function AdminActionPage() {
  const { canAccessAdminAction } = useAccessControl();

  if (!canAccessAdminAction) {
    return <AccessDenied />;
  }

  return <AdminActionModule />;
}
